'use client';

import { useContext } from 'react';
import GlobalContext from '../context/global-context';
import useIsOverwolfIframe from './use-is-overwolf-iframe';

// -----------------------------------------------------------------------------
// Whether the "My Account" entry should be shown, gated per context by config
// flags: MY_ACCOUNT_SHOW_IN_APP inside the Overwolf client iframe,
// MY_ACCOUNT_SHOW_IN_SITE on the public web. isOverwolfIframe defaults false
// until the post-mount check resolves, so the entry never flashes before we know
// which context we're in.
export const useShowMyAccount = (): boolean => {
  const { config } = useContext(GlobalContext);
  const { isOverwolfIframe } = useIsOverwolfIframe();

  const adminParams = config?.publicRuntimeConfig?.adminParams;
  return isOverwolfIframe
    ? (adminParams?.MY_ACCOUNT_SHOW_IN_APP ?? false)
    : (adminParams?.MY_ACCOUNT_SHOW_IN_SITE ?? false);
};

export default useShowMyAccount;
